import { renderLoadingUntilDefined } from "../common/LoadingUntilDefined";
import { useCrewsQuery } from "./useCrewsQuery";
import { CrewSelector } from "./CrewSelector";
import { useMediaQuery } from "../common/hooks/useMediaQuery";
import { lgBreakpoint } from "../App";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { useTranslation } from "react-i18next";

interface Props {
  currentCrewIdentifier: string | undefined;
  setCurrentCrewIdentifier: (i: string | undefined) => void;
  isModalOpen: boolean;
  setIsModalOpen: (value: ((prevState: boolean) => boolean) | boolean) => void;
}

export function CrewDialog({
  currentCrewIdentifier,
  setCurrentCrewIdentifier,
  isModalOpen,
  setIsModalOpen,
}: Props) {
  const { t } = useTranslation();
  const { crews } = useCrewsQuery();

  const isBigScreen = useMediaQuery(`(min-width: ${lgBreakpoint})`);
  const crewSelectorSize = isBigScreen ? "large" : "small";

  const toggle = () => setIsModalOpen((v) => !v);

  const handleSetCurrentCrewIdentifier = (i: string | undefined) => {
    setCurrentCrewIdentifier(i);
    setIsModalOpen(false);
  };

  return (
    <Modal size="xl" isOpen={isModalOpen} fullscreen="md" toggle={toggle}>
      <ModalHeader toggle={toggle}>{t("crew.dialog.title")}</ModalHeader>
      <ModalBody>
        <Row>
          <Col>
            {renderLoadingUntilDefined(crews, (crewInformation) => {
              return (
                <CrewSelector
                  crewInformation={crewInformation}
                  targetCrewIdentifier={currentCrewIdentifier}
                  setTargetCrewIdentifier={handleSetCurrentCrewIdentifier}
                  size={crewSelectorSize}
                />
              );
            })}
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={toggle}>
          {t("common.buttons.close")}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
